import React, { useMemo, useState } from 'react';
import { useTable } from 'react-table';
import { useSortBy } from 'react-table/dist/react-table.development';
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

import QualifierBadgeGroup from './QualifierBadgeGroup';


const toggleRowShown = (rowIndex, shownRows, setShownRows) => {
  setShownRows(shownRows => {
    let shownRowsCopy = [...shownRows]
    shownRowsCopy[rowIndex] = !shownRowsCopy[rowIndex]
    return shownRowsCopy
  })
}

export default function TreatmentTable({ treatments, checkedSideEffects, checkedIndications, checkedFormulations }) {
  const [shownRows, setShownRows] = useState([treatments.forEach(() => false)])
  const columns = useMemo(
    () => [
      {
        Header: "Treatment",
        accessor: row => row.text + (row.fda_approved ? "" : "*")
      },
      {
        Header: "Use For",
        accessor: "indications",
        Cell: ({ cell: { value } }) => <QualifierBadgeGroup
          qualifiers={value}
          checkedQualifiers={checkedIndications}
        />
      },
      {
        Header: "Cost (Generic)",
        accessor: "cost_generic"
      },
      {
        Header: "Risk Factors & Restrictions",
        accessor: "side_effects",
        Cell: ({ cell: { value } }) => <QualifierBadgeGroup
          qualifiers={value}
          checkedQualifiers={checkedSideEffects}
          disqualifier={true}
        />
      },
      {
        Header: "Forms",
        accessor: "formulations",
        Cell: ({ cell: { value } }) => <QualifierBadgeGroup
          qualifiers={value}
          checkedQualifiers={checkedFormulations}
        />
      },
      {
        Header: "Strengths",
        accessor: row => row.strength_names.join(", ")
      },
      {
        Header: "How to Take",
        accessor: (row, i) => i,
        Cell: ({ cell: { value } }) => <Button
          variant="warning"
          onClick={() => toggleRowShown(value, shownRows, setShownRows)}
        >
          Directions
        </Button>
      }
    ],
    [checkedIndications, checkedFormulations, checkedSideEffects, shownRows]
  )
  const data = treatments;

  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    rows, // rows for the table based on the data passed
    prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
  } = useTable(
    {
      columns,
      data
    },
    useSortBy
  );

  // TODO refactor this out to a single place
  const DISQUALIFIER_ROWS = ["side_effects"]
  const QUALIFIER_ROWS = ["indications", "formulations"]
  function disqualify_row(row) {
    return (
      // disqualify if some disqualifier in this row is checked. Need to be zero
      row.original[DISQUALIFIER_ROWS[0]].some(dq => checkedSideEffects.includes(dq)) ||
      // no qualifier in this row is checked. Need at least one
      !row.original[QUALIFIER_ROWS[0]].some(q => checkedIndications.includes(q)) ||
      // no qualifier in this row is checked. Need at least one
      !row.original[QUALIFIER_ROWS[1]].some(q => checkedFormulations.includes(q))
    )
  }

  return (
    <span>
      <Table {...getTableProps}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' 🔽'
                        : ' 🔼'
                      : ''}
                  </span>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <>
                <tr style={disqualify_row(row) ? {
                  textDecoration: "line-through",
                  // fontStyle: "italic",
                  color: "#A0A0A0",
                  backgroundColor: "#E8E8E8"
                } : {}} {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                  })}
                </tr>
                {!shownRows[i] || /* Fix to happen on Directions button click */
                  <tr>
                    <td colSpan="100">
                      <h5>Strengths</h5>
                      <p>{row.original.strengths.join(", ")}</p>
                      <h5>Directions</h5>
                      <p>{row.original.directions}</p>
                      <h5>Other Tips</h5>
                      <p>{row.original.counsel_points}</p>
                    </td>
                  </tr>
                }
              </>
            );
          })}
        </tbody>
      </Table>
      {treatments.some(t => !t.fda_approved) &&
        <p style={{ fontSize: "small" }}>
          *Not FDA Approved
        </p>
      }
    </span>
  );
}